import { Box } from '@/src/packages/components/ui/Box';
import { RefObject, useEffect, useState } from 'react';
import { useWindowScroll } from 'react-use';

const JournalEntryProgress = ({
  contentRef,
}: {
  contentRef: RefObject<HTMLElement>;
}) => {
  const [width, setWidth] = useState(0);

  const { y } = useWindowScroll();

  useEffect(() => {
    if (contentRef.current) {
      const scrollTop = y;

      const contentOffsetTop = contentRef.current.offsetTop;

      const scrollHeight = contentRef.current.clientHeight;

      const scrollPosition =
        scrollTop - contentOffsetTop > 0 ? scrollTop - contentOffsetTop : 0;

      // Substract the viewport, as we want to show completeness once we get to the final segment.
      const percent =
        (scrollPosition / (scrollHeight - window.innerHeight)) * 100;

      setWidth(percent);
    }
  }, [contentRef, y]);

  return (
    <Box
      className="absolute -bottom-[1px] left-0 h-[1px] bg-black"
      style={{ width: `${width}%` }}
    />
  );
};

export { JournalEntryProgress };
